
import Vue from "vue";
import { DatePickerEnum } from "../features/model/enums/DatePickerEnum";

export default Vue.extend({
  name: "CustomDatePicker",

  props: {
    date: String,
    typeDate: {
      type: String,
      default: DatePickerEnum.START_DATE,
      validator(value: DatePickerEnum) {
        return Object.values(DatePickerEnum).includes(value);
      },
    },
    dateLimit: String,
    maxLimit: String,
    minLimit: String,
    label: String,
    maxDayCanSelect: {
      type: Number,
      default: 31,
    },
    dateError: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean, // Corrected this line
      default: false,
    },
  },
  data() {
    const dateFormatted: string | null = "";
    return {
      dateFormatted,
      dateCopy: this.date,
      datePickerMenu: false,
      limitCopy: this.dateLimit,
      datePickerEnum: DatePickerEnum,
      dateErrorMessage: "", // Store error message
    };
  },
  created() {
    this.dateCopy = this.date;
    (this as any).dateFormatted = this.formatDate(this.dateCopy);
  },
  watch: {
    date(val) {
      this.dateCopy = val;
      (this as any).dateFormatted = this.formatDate(this.dateCopy);
    },
  },
  methods: {
    formatDate(date: any) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date: any) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    updateDate() {
      this.datePickerMenu = false;
      this.validateDate();
      this.$emit("update:date", this.dateCopy);
    },
    validateDate() {
      if (!this.dateCopy) {
        this.dateError = true;
        this.dateErrorMessage = "Please select a date.";
      } else {
        this.dateError = false;
        this.dateErrorMessage = "";
      }
    },

    allowedDate(date) {
      const day = new Date(date).getDate();
      return day <= this.maxDayCanSelect;
    },
  },
});
